import React, { useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
import { handleBackFromSrc } from 'fk-cp-common-components/webComponents/V4/app/OrderDetails/V4Helper';
import ContentBlock from 'fk-cp-common-components/webComponents/V4/smartComponents/ContentBlock';
import styles from './CentralWebHeader.css';
import { isFunction } from 'util';
import UAHelper from 'fk-cp-shared/utils/UAHelper';
import IOSNativeCaller from 'fk-cp-shared/components/ios/NativeCaller';
var HeaderContent = function (props) {
    var _a, _b;
    var title = props.title, _c = props.showClose, showClose = _c === void 0 ? false : _c, onBackAction = props.onBackAction, iosBackPressEnabled = props.iosBackPressEnabled, _d = props.isNativeHeaderHidden, isNativeHeaderHidden = _d === void 0 ? false : _d, _e = props.isWebHeaderHidden, isWebHeaderHidden = _e === void 0 ? true : _e, portalDomNode = props.portalDomNode, _f = props.dynamicContents, dynamicContents = _f === void 0 ? {} : _f;
    var searchParams = new URLSearchParams(window.location.search);
    var hideBackForMinutesOrders = (((_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname) === '/rv/orders' || ((_b = window.location) === null || _b === void 0 ? void 0 : _b.pathname) === '/rv/orders/search') && searchParams.get("pageSrc") === 'minutesOrders';
    /** Hide back chevron on minutes orders list; still show close (X) when configured */
    var showBackControl = !hideBackForMinutesOrders || showClose;
    var hideNativeHeader = !isNativeHeaderHidden || isWebHeaderHidden;
    var handleBackClick = useCallback(function () {
        if (isFunction(onBackAction)) {
            // Dispatch the action instead of calling a function
            onBackAction();
        }
        else {
            // Fallback to default behavior
            handleBackFromSrc(window.location);
        }
    }, [onBackAction, window.location]);
    var handleIosBackPress = useCallback(function () {
        if (UAHelper._isIOS() && IOSNativeCaller.bridgeAvailable()) {
            var isHandleBack_1 = typeof onBackAction === 'function' && iosBackPressEnabled;
            setTimeout(function () {
                IOSNativeCaller.run('setCrossButtonAndHandleBack', {
                    isHandleBackEnabled: isHandleBack_1
                });
            }, 400);
        }
    }, [onBackAction, iosBackPressEnabled]);
    useEffect(function () {
        var _a, _b;
        if (typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.Android) === null || _b === void 0 ? void 0 : _b.setHandleBackPress) === 'function') {
            /* Register `onBackPress` before enabling back press handling to avoid a race condition.
            * The native side checks if `setHandleBackPress` is true before calling `onBackPress`.
            */
            window['onBackPress'] = handleBackClick;
            setTimeout(function () {
                window.Android.setHandleBackPress(true);
            }, 0);
        }
        else if (UAHelper._isIOS() && IOSNativeCaller && IOSNativeCaller.bridgeAvailable()) {
            window['onBackPress'] = handleBackClick;
        }
    }, [handleBackClick]);
    useEffect(function () {
        handleIosBackPress();
    }, [handleIosBackPress]);
    if (hideNativeHeader) {
        return null;
    }
    // This is injected from the page level Header widget
    var actionProps = window.__ACTION_PROPS__;
    var header = (<React.Fragment key={window.location.href}>
			<div className={styles.headerContainer}>
				{showBackControl ? (<div className={styles.backButton} onClick={handleBackClick}>	
					{showClose ?
        <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
						<path d="m1.063 1l12.3 12.425m.063-12.362l-12.426 12.3" stroke="#212121" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
					</svg>
        : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<g clipPath="url(#clip0_5921_33391)">
							<path d="M20.25 12H3.75" stroke="#333333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M10.5 5.25L3.75 12L10.5 18.75" stroke="#333333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
						</g>
						<defs>
							<clipPath id="clip0_5921_33391">
								<rect width="24" height="24" fill="white"/>
							</clipPath>
						</defs>
					</svg>}
				</div>) : null}
				<div className={styles.headerTitle + " " + (showBackControl ? '' : styles.titleSpace)}>{title}</div>
				{Boolean(dynamicContents && dynamicContents.contents && dynamicContents.contents.length > 0) && (<div className={styles.headerContentList}>
						<ContentBlock {...dynamicContents} actionProps={actionProps}/>
					</div>)}
			</div>
			
			<div className={styles.dummyRelativeNew}/>
		</React.Fragment>);
    var portalDomElement = document.getElementById(portalDomNode);
    return portalDomElement ? ReactDOM.createPortal(header, portalDomElement) : header;
};
var mapStateToProps = function (_a) {
    var selfServe = _a.selfServe;
    var _b, _c, _d, _e, _f, _g, _h, _j;
    return ({
        title: (_b = selfServe.headerContent) === null || _b === void 0 ? void 0 : _b.title,
        showClose: (_c = selfServe.headerContent) === null || _c === void 0 ? void 0 : _c.showClose,
        onBackAction: (_d = selfServe.headerContent) === null || _d === void 0 ? void 0 : _d.onBackAction,
        iosBackPressEnabled: (_e = selfServe.headerContent) === null || _e === void 0 ? void 0 : _e.iosBackPressEnabled,
        portalDomNode: (_f = selfServe.headerContent) === null || _f === void 0 ? void 0 : _f.portalDomNode,
        isNativeHeaderHidden: (_g = selfServe.headerContent) === null || _g === void 0 ? void 0 : _g.isNativeHeaderHidden,
        isWebHeaderHidden: (_h = selfServe.headerContent) === null || _h === void 0 ? void 0 : _h.isWebHeaderHidden,
        dynamicContents: (_j = selfServe.headerContent) === null || _j === void 0 ? void 0 : _j.dynamicContents
    });
};
export { HeaderContent };
export default connect(mapStateToProps)(withRouter(HeaderContent));
